// src/routes/AppRoutes.tsx
import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import AppRouter from "./AppRouter.tsx";

const router = createBrowserRouter(AppRouter);

const AppRoutes: React.FC = () => {
  return <RouterProvider router={router} />;
};

export default AppRoutes;
